import React, { useCallback, useEffect, useRef, useState } from 'react';
import GridSelectFilter from '../../common/GridSelectFilter';
import type { TrailerMoveFilterOption, TrailerMovesLayoutStack } from '../types';
import {
  DEFAULT_TRAILER_MOVES_FILTER,
  TRAILER_MOVES_FILTER_LIST,
} from './constants';

interface TrailerMovesGridFilterProps {
  stack: TrailerMovesLayoutStack;
  headerId: string;
}

const TrailerMovesGridFilter = ({ stack, headerId }: TrailerMovesGridFilterProps) => {
  const [selectedFilter, setSelectedFilter] = useState<TrailerMoveFilterOption>(
    DEFAULT_TRAILER_MOVES_FILTER
  );
  const selectedFilterRef = useRef(selectedFilter);
  selectedFilterRef.current = selectedFilter;

  const emitFilterChange = useCallback(
    (option: TrailerMoveFilterOption, isFilterMounted = false) => {
      const hasChanged = selectedFilterRef.current?.value !== option?.value;
      if (hasChanged || isFilterMounted) {
        stack.layoutManager.eventHub.emit(`${headerId}_selectFilterSelected`, {
          option,
          isFilterMounted,
        });
      }
      if (hasChanged) {
        setSelectedFilter(option);
      }
    },
    [stack.layoutManager.eventHub, headerId]
  );

  const onExternalReset = useCallback((option?: TrailerMoveFilterOption) => {
    if (option?.value) {
      setSelectedFilter(option);
    }
  }, []);

  const onFilterChange = useCallback(
    (option: TrailerMoveFilterOption) => {
      emitFilterChange(option);
    },
    [emitFilterChange]
  );

  useEffect(() => {
    emitFilterChange(DEFAULT_TRAILER_MOVES_FILTER, true);
    const resetFilterEvent = `${headerId}_resetFilter`;
    const eventHub = stack.layoutManager.eventHub;
    eventHub.on(resetFilterEvent, onExternalReset as (...args: unknown[]) => void);
    return () => {
      eventHub.off(resetFilterEvent, onExternalReset as (...args: unknown[]) => void);
    };
  }, [emitFilterChange, onExternalReset, headerId, stack.layoutManager.eventHub]);

  return (
    <GridSelectFilter
      value={selectedFilter}
      onChange={onFilterChange}
      options={TRAILER_MOVES_FILTER_LIST}
    />
  );
};

export default TrailerMovesGridFilter;
